import './Login.css';
import { toast } from 'react-hot-toast';
import { useAuth } from '../../hooks/useAuth';
import { TextInput } from '@tremor/react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import PaparazzoLogo from '../../commons/images/svgs/paparazzo_logo_vertical.svg';

const Login = () => {
  const { signIn: supabaseSignIn, user: currentUser } = useAuth();
  const navigate = useNavigate();

  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (currentUser) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  const handleLogin = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    try {
      // Sign in with Supabase using email and password
      const { data, error } = await supabaseSignIn(user, password);

      if (error) {
        toast.error('Login fallito: dati mancanti o errati');
        console.error('Login error:', error);
        return;
      }

      if (data.user) {
        // Check if user is disabled (you can add custom metadata to users)
        const userMetadata = data.user.user_metadata;
        if (userMetadata?.disabled) {
          toast.error('Login fallito: account disabilitato');
          return;
        }

        // Login successful - user will be automatically available via useAuth hook
        toast.success('Login effettuato con successo!');
        setTimeout(() => {
          navigate('/dashboard');
        }, 300);
      }
    } catch (err) {
      toast.error('Login fallito: dati mancanti o errati');
      console.error('Failed to log in', err);
    }
  };

  return (
    <div className="login">
      <form className="form">
        <div className="form__header">
          <img
            src={PaparazzoLogo}
            alt="Paparazzo"
            className="app-logo"
            decoding="async"
          />
        </div>
        <div className="form__body">
          <span className="h1">Accedi</span>

          <TextInput
            name="username"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            placeholder="Username"
            icon={undefined}
            error={false}
            errorMessage=""
            disabled={false}
            maxWidth="max-w-none"
            marginTop="mt-0"
          />
          <input
            type="password"
            autoComplete="current-password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            disabled={false}
          />

          <button className="cta" onClick={handleLogin}>
            Accedi
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
